import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  title = 'Dca Site-web';
  constructor(  ){
    const ahora = new Date();
    const nameStorage= ahora.getHours() + ':' + ahora.getMinutes() + ':' + ahora.getSeconds()
    sessionStorage.setItem('START ' + nameStorage  , JSON.stringify('Rperez START App:' ));
    localStorage.setItem('START ' + nameStorage, JSON.stringify('Rperez START App'));
  }

  ngOnDestroy(){
    sessionStorage.setItem('END', JSON.stringify('Rperez END App'));
  }

}